//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('businesscoSettings', {
//        templateUrl: 'views/components/views/businesscoSettings/businesscoSettings.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'businesscoSettingsService', function ($stateParams, businesscoSettingsService) {
//            const vm = this;
//            let businessCoNo = $stateParams.businessco_no;

//            vm.model = {
//                itemsListGroups: []
//            };

//            async function loadSettingGroups() {
//                vm.model.itemsListGroups = await businesscoSettingsService.listSettingGroups({ businessco_no: businessCoNo });
//            }

//            vm.$onInit = function () {
//                loadSettingGroups();
//            }
//		}]
//	});
//})();
